module.exports = __webpack_public_path__ + "img/wcf.f1e9025e.svg";